export default {
      
  reports: {
    usersByStatus: "Users By Status",
    usersByGender: "Users By Gender",
    gen: "Gender",
    gender: "Gender Chart",
    male: "Male",
    female: "Female",
    other: "Other",
    unspefied: "Unspecified",
    byCountry: "By Country",
    avgPriceFarmer: "Average Selling Price By All Farmers",
    avgPrice: "Average Selling Price Per Farmer",
    selectYear: "Select Year",
    total: "Total",
    farmerName: "Farmer Name",
    farmerProdChart: "Farmer Production Chart",
    production: "Production",
    byProduction: "By Production",
    byName: "By Name",
    descending: "Descending",
    ascending: "Ascending",
    buyingStationProdChart: "Buying Station Production Chart",
    buyingStation: "Buying Station",
    buyingStationName: "Buying Station Name",
    dryMilling: "Dry Milling",
    dryMillingName: "Dry Milling Name",
    dryMillingProdChart: "Dry Milling Production Chart",
    view: "View",
    date: "Date",
    reports: "Reports",
    today: "Today",
    week: "Week",
    month: "Month",
    year: "Year",
    all: "All",
    selectCrop: "Select Crop",
    selectRegion: "Select Region",
    selectProvinceState: "Select Province/State",
    downloadPdfReport: "Download PDF Report",
    export: "Export",
    search: "Search",
    yield: "Yield",
    avgAreaPerUnit: "Avg Area in {unit}",
    yieldPerUnit: "Yield/{unit}",
    averageSellingPriceByAllFarmers: "Average Selling Price by All Farmers",
    averageSellingPricePerFarmer: "Average Selling Price per Farmer",
    pricePaid: "Price Paid",
    pests: {
      pestReport: "Pest Report",
      filterByCrops: "Filter By Crops",
      pestStatistics: "Pest Statistics",
      regions: "Regions",
      occurrences: "Occurrences",
      pestChart: "Pest Chart",
      totalArea: "Total Area",
      pestName: "Pest Name",
      region: "Region",
      crop: "Crops",
      listByLand: "List By Land",
    },
    regions: {
      regionalReport: "Regional Report",
      listByFarm: "List by Farm",
      listByFarmers: "List by Farmers",
      listByYield: "List by Yield",
      regionalStatistics: "Regional Statistics",
      countries: "Countries",
      states: "States/Provinces",
      city: "City/Town/Village",
      farmsIn: "Farms in",
      regionalChart: "Regional Chart",
      farms: "Farms",
      regionName: "Region Name",
      farmers: "Farmers",
      yield: "Yield/Acre",
    },
    dashboard: {
      topCharts: "Top Charts",
      regions: "Regions",
      noOfFarms: "No. of Farms/Region",
      provinces: "Provinces states",
      landArea: "LandArea",
      avgFarmerLand: "Avg. Farmer land",
      viewAll: "View All",
      crops: "Crops",
      plantedAreaCrop: "Planted Area/Crop",
      plantedArea: "Planted Area",
      avgYieldCrop: "Avg. Yield/Crop",
      averageYield: "Average Yield",
      yieldChart: "Yield Chart",
      selectFarm: "Select Farm",
      soilQuality: "Soil Quality",
      pests: "Pests",
      occurrences: "occurrences",
      equipments: "Equipments",
      goalAchievedChart: "Goals Achieved Chart",
      soilValues: "Soil Values",
      soil: "Soil",
      showReport: "Show reports on Dashboard",
      selectAll: "Select All",
    },
    weight: "Weight",
    quality: "Quality",
    price: "Price",
  },
}